import { OperatorAreaDetails } from '../pages/private/operatorArea/operatorAreaDetails';
import {
  DockingPlace,
  GenericQueryParamsType,
  GenericResponse,
} from '../types';
import { getHeaders, tosApi } from './tosApi';

type BerthsResponse = GenericResponse & {
  results: Array<any>;
};
export const dockingPlacesApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    getBerths: build.query<
      { results: Array<any>; count: number },
      GenericQueryParamsType & {
        shipType?: string | void;
        placeType?: string | void;
        operator?: string | void;
        berthName?: string;
        // Por padrão lista apenas os ativos, que é o esperado nas seleções de
        // atracação e planejamento. 'ALL' lista ativos e inativos, para o cadastro
        active?: boolean | 'ALL';
      }
    >({
      query: (arg) => {
        const {
          shipType,
          placeType,
          operator,
          berthName,
          page_size,
          page,
          active,
        } = arg;
        return {
          url: `/maritime/docking-places`,
          method: 'GET',
          headers: getHeaders,
          params: {
            active: active === 'ALL' ? undefined : String(active ?? true),
            ship_type: shipType,
            place_type: placeType,
            operator,
            name: berthName,
            page,
            page_size,
          },
        };
      },
      transformResponse: (response: BerthsResponse) => {
        response.results.forEach((berth: any) => {
          berth.key = berth.tag;
          berth.id = berth.tag;
        });
        return { results: response.results, count: response.count };
      },
      keepUnusedDataFor: 300,
      providesTags: () => [{ type: 'DockingPlace', code: '1' }],
    }),
    createBerth: build.mutation<DockingPlace, DockingPlace>({
      query: (berth) => {
        return {
          url: '/maritime/docking-places',
          method: 'POST',
          headers: getHeaders,
          body: berth,
        };
      },
      invalidatesTags: () => [{ type: 'DockingPlace', code: '1' }],
    }),
    updateBerth: build.mutation<DockingPlace, DockingPlace>({
      query: (berth) => {
        return {
          url: `/maritime/docking-places/${berth.tag}`,
          method: 'PUT',
          headers: getHeaders,
          body: berth,
        };
      },
      invalidatesTags: () => [{ type: 'DockingPlace', code: '1' }],
    }),
  }),
});

export const {
  useGetBerthsQuery,
  useLazyGetBerthsQuery,
  useCreateBerthMutation,
  useUpdateBerthMutation,
} = dockingPlacesApi;
